const getUniqueItems = <T>(data, key: string): T => {
  const uniqueMap = new Map();
  data.forEach((obj) => {
    const k = obj[key];
    if (!uniqueMap.has(k)) {
      uniqueMap.set(k, obj);
    }
  });

  return Array.from(uniqueMap.values()) as T;
};

function capitalizeFirstLetter(str) {
  return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
}

const USER_ROLES = [
  {
    name: "Guest",
    id: 0,
  },
  {
    name: "Super Admin",
    id: 1,
  },
  {
    name: "Admin",
    id: 2,
  },
  {
    name: "Merchant",
    id: 3,
  },
  {
    name: "Customer",
    id: 4,
  },
  {
    name: "Rider",
    id: 5,
  },
];

const QUERY_UTIL = {
  limit: 15,
  rating: 3,
};

export { getUniqueItems, capitalizeFirstLetter, USER_ROLES, QUERY_UTIL };
